import { callEndpoint } from '../../backend';
import { getStore } from '../../store';
import { updateShareNotificationsStatus } from '../../store/modules/app-controls';

// Update the store with the share notifications state
const setNewShareNotificationsStatus = async (newNotifications: boolean) => {
  getStore().dispatch(updateShareNotificationsStatus(newNotifications));
};

const getNewSharingActivities = async () => {
  if (getStore().getState().backendService.currentMember) {
    const { hasUnreadSharingActivities } = await callEndpoint(
      callEndpoint.endpoints.checkForNewSharingActivities,
      {},
    );
    await setNewShareNotificationsStatus(hasUnreadSharingActivities);
  }
};

export const markSharingActivitiesAsRead = async (): Promise<void> => {
  if (getStore().getState().backendService.currentMember) {
    await callEndpoint(
      callEndpoint.endpoints.updateSharingActivitiesReadStatusByMember,
    );
  }

  getNewSharingActivities();
};

export const appendInvitationParam = (
  inputUrl: string,
  invitationId: string,
): string => {
  const url = new URL(inputUrl);
  const invitationParamKey = 'invitation';

  if (invitationId) {
    const searchParams = new URLSearchParams(url.search);
    searchParams.delete(invitationParamKey);
    searchParams.append(invitationParamKey, invitationId);
    return `${url.origin}${url.pathname}?${searchParams.toString()}`;
  }
  return url.href;
};

export const initialize = (): void => {
  getNewSharingActivities();

  // Check for new sharing notifs .......... every 5 minutes.
  setInterval(async () => {
    getNewSharingActivities();
  }, 1000 * 60 * 5);
};
